module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-dropdown', {
    ref: "dropDownSearch",
    staticClass: "dropdown-search",
    attrs: {
      "text": String(_vm.selectedElement),
      "variant": "secondary"
    }
  }, [(_vm.isSearch) ? _c('b-dropdown-header', {
    staticClass: "dropdown_search_search"
  }, [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.search()
      }
    },
    model: {
      value: (_vm.searchPhrase),
      callback: function($$v) {
        _vm.searchPhrase = $$v
      },
      expression: "searchPhrase"
    }
  }), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropdown_elements dropdown_search_elements"
  }, [(_vm.showEmpty) ? _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        return _vm.selectElement(null)
      }
    }
  }, [_vm._v("Brak")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredElements), function(element) {
    return _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          return _vm.selectElement(element)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getLabel(element)) + "\n        ")])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c2756aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DropdownSearch.vue
// module id = 780
// module chunks = 0